.noPreview {
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(var(--size) * 0.15);
  gap: calc(var(--size) * 0.05);
  line-height: 1.1;

  svg {
    color: var(--x-color-text-primary-disabled);
    font-size: calc(var(--size) * 0.35);
  }
}
